<button mat-raised-button (click)="onNewTagClick()">Add tag</button>
<button mat-raised-button (click)="onConnectTagsByMac()">Add tags based on list of macs</button>
<button mat-raised-button (click)="onSelectTagsByMac()">Select wearables based on list of macs</button>
<button
  mat-raised-button
  color="primary"
  (click)="copySelectedMacsToClipboard()"
  [disabled]="selected.selected.length === 0"
>
  Copy {{ selected.selected.length }} selected MACs to clipboard
</button>
<button mat-button (click)="onDeleteSelectedClick()" color="warn">Remove {{ selected.selected.length }} tags.</button>
<button mat-raised-button color="primary" (click)="exportSelectedToCsv()" [disabled]="selected.selected.length === 0">
  Export {{ selected.selected.length }} selected to CSV
</button>
<span>{{ tags.length }} tags</span>

<div class="filter-container">
  <!-- Assigned to Person filter -->
  <mat-form-field appearance="fill" class="filter-field">
    <mat-label>Assigned to Person</mat-label>
    <mat-select [(value)]="filterAssignedToPerson" (selectionChange)="applyFilters()">
      <mat-option value="all">All</mat-option>
      <mat-option value="assigned">Assigned</mat-option>
      <mat-option value="unassigned">Unassigned</mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Is Activated filter -->
  <mat-form-field appearance="fill" class="filter-field">
    <mat-label>Is Activated</mat-label>
    <mat-select [(value)]="filterIsActivated" (selectionChange)="applyFilters()">
      <mat-option value="all">All</mat-option>
      <mat-option value="activated">Activated</mat-option>
      <mat-option value="notactivated">Not Activated</mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Battery Status filter -->
  <mat-form-field appearance="fill" class="filter-field">
    <mat-label>Battery Status</mat-label>
    <mat-select [(value)]="filterBatteryStatus" (selectionChange)="applyFilters()" multiple>
      <mat-option [value]="status" *ngFor="let status of batteryStatusOptions">{{ status }}</mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Missing filter -->
  <mat-form-field appearance="fill" class="filter-field">
    <mat-label>Missing</mat-label>
    <mat-select [(value)]="filterIsMissing" (selectionChange)="applyFilters()">
      <mat-option value="all">All</mat-option>
      <mat-option value="missing">Missing</mat-option>
      <mat-option value="notmissing">Not missing</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-checkbox [(ngModel)]="filterShowOnlySelected" (change)="applyFilters()" class="filter-checkbox">
    Show only selected tags
  </mat-checkbox>

  <button mat-stroked-button class="clear-filter-btn" (click)="clearFilters()">Clear filters</button>
  <button mat-stroked-button color="primary" (click)="selectAllFiltered()">Select all filtered</button>
  <span class="results-info">{{ dataSource.filteredData.length }} / {{ tags.length }} tags shown</span>
</div>

<mat-table #tagTable [dataSource]="dataSource" matSort (matSortChange)="onSortChange($event)">
  <ng-container matColumnDef="select">
    <mat-header-cell *matHeaderCellDef class="w-64">
      <mat-checkbox
        (change)="$event ? masterToggle() : null"
        [checked]="selected.hasValue() && isAllSelected()"
        [indeterminate]="selected.hasValue() && !isAllSelected()"
        class="w-64"
      >
      </mat-checkbox>
    </mat-header-cell>
    <mat-cell *matCellDef="let row" class="w-64">
      <mat-checkbox
        (click)="$event.stopPropagation()"
        (change)="$event ? selected.toggle(row) : null"
        [checked]="selected.isSelected(row)"
        class="w-64"
      >
      </mat-checkbox>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="id">
    <mat-header-cell *matHeaderCellDef mat-sort-header="id"> Id </mat-header-cell>
    <mat-cell *matCellDef="let element"
      ><button mat-button [routerLink]="[element.hardwareDevice.id]">{{ element.hardwareDevice.id }}</button></mat-cell
    >
  </ng-container>
  <ng-container matColumnDef="bleMacAddress">
    <mat-header-cell *matHeaderCellDef mat-sort-header="bleMacAddress"> BleMacAddress </mat-header-cell>
    <mat-cell *matCellDef="let element"> {{ element.hardwareDevice.bleMacAddress }} </mat-cell>
  </ng-container>
  <ng-container matColumnDef="createdAt">
    <mat-header-cell *matHeaderCellDef mat-sort-header="createdAt"> Created </mat-header-cell>
    <mat-cell *matCellDef="let element">
      {{ formatDate(element.hardwareDevice.createdAt) }}
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="firstTurnOnUtcDateTime">
    <mat-header-cell *matHeaderCellDef mat-sort-header="firstTurnOnUtcDateTime">
      FirstTurnOnUtcDateTime
    </mat-header-cell>
    <mat-cell *matCellDef="let element"> {{ formatDate(element.firstTurnOnUtcDateTime) }} </mat-cell>
  </ng-container>
  <ng-container matColumnDef="assignedToPerson">
    <mat-header-cell *matHeaderCellDef mat-sort-header="assignedToPerson"> Assigned to Person </mat-header-cell>
    <mat-cell *matCellDef="let element">
      <span [class]="isAssignedToPerson(element) ? 'status-ok' : ''">
        {{ isAssignedToPerson(element) ? 'Yes' : 'No' }}
      </span>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="missingSince">
    <mat-header-cell *matHeaderCellDef mat-sort-header="missingSince"> Missing since </mat-header-cell>
    <mat-cell *matCellDef="let element">
      <span [class]="isMissing(element) ? 'status-warning' : ''">
        <ng-container *ngIf="getMissingSince(element) as missingSince; else notMissing">
          {{ formatDate(missingSince) }}
        </ng-container>
        <ng-template #notMissing>Not missing</ng-template>
      </span>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="isSubscription">
    <mat-header-cell *matHeaderCellDef mat-sort-header="isSubscription"> Is subscription </mat-header-cell>
    <mat-cell *matCellDef="let element">
      {{ element.isBoughtUnderSubscription ? 'Yes' : 'No' }}
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="productionTime">
    <mat-header-cell *matHeaderCellDef mat-sort-header="productionTime"> Production time </mat-header-cell>
    <mat-cell *matCellDef="let element">
      {{ element.hardwareDevice.productionDate ? formatDate(element.hardwareDevice.productionDate) : '' }}
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="batteryStatus">
    <mat-header-cell *matHeaderCellDef mat-sort-header="batteryStatus"> Battery Status </mat-header-cell>
    <mat-cell *matCellDef="let element">
      <span
        [class]="
          getBatteryStatus(element) == 'Ok' || getBatteryStatus(element) == 'NeverTurnedOn'
            ? 'status-ok'
            : 'status-warning'
        "
      >
        {{ getBatteryStatus(element) }}
      </span>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="options">
    <mat-header-cell *matHeaderCellDef> Options </mat-header-cell>
    <mat-cell *matCellDef="let element">
      <button mat-button color="warn" (click)="deleteTag(element)">Disconnect</button>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumnsTags"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumnsTags"></mat-row>
</mat-table>
